/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/travelInformation/bagTracker.js
*    TO   --> ./legacy-web/src/main/assets/js/travel-information/bag-tracker.js
**/

/*
 * bagTracker.js
 */

//Initialize sandbox
AAcom('utilities', 'ajax', 'aaCollapse', function(AAUI) {

    AAUI.populateBagInputs = function() {
        var searchBy = $j("#searchBy").find('option:selected').val();
        var recordLocOption = $j("#recordLocOption");
      
        if (searchBy === "bagTagNumber") {
           recordLocOption.hide();
           AAUI.initClearInput("#recordLocOption");
           $j("#bagTagNum").show();
        } else {
            recordLocOption.show();
            AAUI.initClearInput("#bagTagNum");
            $j("#bagTagNum").hide();
        }
    };

    AAUI.initBagTrackerSearchBy = function() {
        AAUI.populateBagInputs();
        AAUI.onChange('select[name="searchBy"]', function() {
            AAUI.populateBagInputs();
        });
    };

    AAUI.initCollapse = function() {
        var bags = $j(".historyTableLink");
        if (bags.length) {
            bags.each(function(index, bag) {
                AAUI.collapse({
                    selector: "#" + bag.id,
                    target: $j(bag).data("href"),
                    collapsed: true,
                    accessibleText: {
                        hide: AAUI.getProperty("bagTrackerHide"),
                        show: AAUI.getProperty("bagTrackerShow")
                    }
                }).init();
            });
        }
    };
    AAUI.initClearInput = function(inputContainer) {
        AAUI.resetFormFields(inputContainer);
        AAUI.clearFormErrors(inputContainer);
    };

    AAUI.initPage = function(pageLoad) {
        pageLoad = pageLoad || false;
        if (pageLoad) {
            AAUI.initBagTrackerSearchBy();
            AAUI.initCollapse();
        }
    };

    $j(document).ready(function() {
        AAUI.initPage(true);
    });

    //needed for back page being cached
    $j(window).bind("pageshow", function(event) {
        if (event.originalEvent.persisted) {
        	location.reload();
        }
    });
});